import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import moment from 'moment'
import {StaticQuery, graphql} from 'gatsby'
import {ClipLoader} from 'react-spinners'
import {withTheme} from 'emotion-theming'

import Blob from '../Blob'
import MeetupsLoader from '../MeetupsLoader'
import Button, {NoInteractiveButton} from '../Button'

const RootContainer = styled.div`
	margin: -1.5rem 0;
	position: relative;
	z-index: 1;
`

const Title = styled.div`
	font-size: ${props => props.theme.fontSizes.big18};
	font-weight: ${props => props.theme.fontWeights.bold};
	max-width: 20rem;
`

const Meta = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
	font-weight: ${props => props.theme.fontWeights.regular};
	margin: 0.5rem 0 1rem;
`

const BlobStyled = styled(Blob)`
	margin: 1.5rem 0;
`
BlobStyled.defaultProps = {
	minimalWidth: true,
}

const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`


const Spinner = styled(ClipLoader)`
`
Spinner.defaultProps = {
	sizeUnit: 'rem',
	size: '3',
}

const extractOrgId = (fullUrl) => {
	const splitBySlash = fullUrl.replace(/\/$/, '').split('/')
	return splitBySlash[splitBySlash.length - 1]
}


const ErrorContainer = styled.div`
`

const ErrorTitle = styled.div`
	margin-bottom: 2rem;
`

function LatestMeetups({className, theme}) {
	return <StaticQuery query={graphql`
		{
		  meetups: file(relativePath: {eq: "pages/meetupsPage.json"}) {
			childPagesJson {
			  meetupProfileUrl
			}
		  }
		}
	`} render={(data) => {
		return <RootContainer className={className}>
			<MeetupsLoader
				error={({retry}) => <ErrorContainer>
					<ErrorTitle>Error while loading meetups</ErrorTitle>
					<NoInteractiveButton onClick={retry}>Try again</NoInteractiveButton>
				</ErrorContainer>}
				spinner={<LoadingContainer><Spinner color={theme.colors.main}/></LoadingContainer>}
				orgId={extractOrgId(data.meetups.childPagesJson.meetupProfileUrl)}>
				{({future}) => <>
					{future.slice(0, 2).map((one, i) => <BlobStyled blobType={(i % 2) + 2}>
						<Title>{one.name}</Title>
						<Meta>{moment(one.time).format('dddd, MMM D, YYYY, HH:mm')}</Meta>
						<Button to={one.link} target='_blank'>See details</Button>
					</BlobStyled>)}
				</>}
			</MeetupsLoader>
		</RootContainer>
	}}/>
}


LatestMeetups.propTypes = {
	className: PropTypes.string,
	theme: PropTypes.any.isRequired,
}

LatestMeetups.defaultProps = {
	className: '',
}

export default withTheme(LatestMeetups)
